import React from "react";
import { ImageContainer } from "./styles";
import { Result } from "antd";
import "./magicLoaderStyle.css";
import { Column, Row } from "../../themes/globalStyle";

const WaitingMessage: React.FC = (): JSX.Element => {
  return (
    <ImageContainer>
      <Result
        title={<div style={{marginTop: '4rem'}}>Seu arquivo está em produção!</div>}
        subTitle={
          <Column style={{ alignItems: "center" }}>
            <Row>
              Em menos de 24h ele será revisado por um de nossos colaboradores e
              poderá ser acessado.
            </Row>
            <Row>
              Parece mágica mas é CoProdux: a colaboração perfeita entre humanos
              e IA.
            </Row>
          </Column>
        }
        icon={
          <div className="scene">
            <div className="objects">
              <div className="square"></div>
              <div className="circle"></div>
              <div className="triangle"></div>
            </div>
            <div className="wizard">
              <div className="body"></div>
              <div className="right-arm">
                <div className="right-hand"></div>
              </div>
              <div className="left-arm">
                <div className="left-hand"></div>
              </div>
              <div className="head">
                <div className="beard"></div>
                <div className="face">
                  <div className="adds"></div>
                </div>
                <div className="hat">
                  <div className="hat-of-the-hat"></div>
                  <div className="four-point-star --first"></div>
                  <div className="four-point-star --second"></div>
                  <div className="four-point-star --third"></div>
                </div>
              </div>
            </div>
          </div>
        }
      />
    </ImageContainer>
  );
};

export default WaitingMessage;
